const ProfileInfo = {
  components: {
    'term-search': TermSearch,
    'dmtk-textarea': FormTextArea,
    'birthdate-picker': BirthdatePicker,
    'uploader-avatar': UploaderAvatar,
  },
  mixins: [ProfileValidation],
  data() {
    return {
      labels: {
        url: 'Este campo <strong>no es obligatorio</strong>, pero si lo quieres rellenar debes introducir una URL válida',
        required: 'Debes rellenar este campo para poder publicar tu perfil',
      },
    };
  },
  computed: {
    full_name() {
      return (
        (this.profile.first_name || '') + '' + (this.profile.last_name || '')
      );
    },
    save() {
      return this.$dmtk.profile.save;
    },
    ...Vuex.mapState(['signup', 'profile']),
  },
  watch: {
    'profile.avatar'(avatar, old) {
      if (!old) return;
      let user = domestiko.user;
      user.avatar = avatar.url;
      domestiko.login(user);
    },
  },
  mounted() {
    if (!this.signup) {
      this.$v.profile.$touch();
    }
  },
  methods: {
    urlize(value) {
      if (value && value.substring(0, 4) !== 'http') {
        value = 'https://' + value;
      }
      return value;
    },
    mayClean() {
      if (!this.$v.profile.url.valid) {
        this.profile.url = '';
      }
      if (!this.$v.profile.linkedin.valid) {
        this.profile.linkedin = '';
      }
    },
    isCompany() {
      return this.profile.type === 'E';
    },
    show_warning(field) {
      return this.$v.profile[field].$dirty && this.$v.profile[field].$invalid;
    },
    add_location_to_notifications() {
      const exists =
        this.profile.alerts.filter((alert) => {
          return alert._id === this.profile.location._id;
        }).length > 0;
      if (!exists) {
        this.profile.alerts.push({
          _id: this.profile.location._id,
          title: this.profile.location.title,
        });
      }
    },
  },
  template: `
    <div>

      <div class="uk-grid">
        <div class="uk-width-2-5@m">
          <h3 v-if="isCompany()">Logotipo</h3>
          <h3 v-else>Imagen de perfil</h3>
          <div class="uk-text-center">
            <uploader-avatar
              v-model="profile.avatar"
              :name="full_name"
            ></uploader-avatar>
            <p>
              Pincha en la imagen para cambiarla.
              <a href="/ayuda/guia-para-subir-imagenes/" class="icon-info" target="_blank"></a>
            </p>
          </div>
        </div>
        <div class="uk-width-3-5@m">
          <h3 v-if="!isCompany()">Presentación</h3>
          <h3 v-else>Sobre tu empresa</h3>
          <dmtk-textarea
            rows="10"
            :value="profile.description"
            @blur="$v.profile.description.$touch()"
            @input="profile.description = $event; $v.profile.description.$touch()"
            placeholder="Escribe aquí tu texto de presentación"
          ></dmtk-textarea>
          <template v-if="$v.profile.description.$dirty">
            <span class="uk-text-danger" v-if="!$v.profile.description.required">
              {{ this.labels.required }}
            </span>
            <span class="uk-text-warning" v-else-if="!$v.profile.description.short">
              Por favor añade más texto a tu presentación
            </span>
          </template>
        </div>
      </div>

      <div class="uk-grid">
        <div class="uk-width-1-1">
          <h3 v-if="!isCompany()" class="uk-margin-remove">Datos personales</h3>
          <h3 v-else class="uk-margin-remove">Datos empresa</h3>
        </div>
        <div class="uk-width-1-2@m">
          <div class="uk-form-controls uk-margin-top">
            <label v-if="!isCompany()">Nombre</label>
            <label v-else>Empresa</label>
            <input
              type="text" class="uk-input" v-model="profile.first_name"
              @blur="$v.profile.first_name.$touch()"
              uk-tooltip="Este nombre que aparecerá en tu perfil público"
            />
            <span class="uk-text-danger" v-if="show_warning('first_name')">
            	{{ this.labels.required }}
          </span>
          </div>
          <div class="uk-form-controls uk-margin-top" v-if="!isCompany()">
            <label>Apellidos</label>
            <input
              type="text" class="uk-input" v-model="profile.last_name"
              @blur="$v.profile.last_name.$touch()"
            />
            <span class="uk-text-danger" v-if="show_warning('last_name')">
            	{{ this.labels.required }}
          	</span>
          </div>
        </div>
        <div class="uk-width-1-2@m">
          <div class="uk-form-controls uk-margin-top">
            <label>Localidad</label>
            <term-search
              placeholder="¿Dónde?"
              taxonomy="regional" scope="city"
              v-model="profile.location"
              @blur="add_location_to_notifications"
            ></term-search>
            <span class="uk-text-danger" v-if="show_warning('location')">
            	{{ this.labels.required }}
          </span>
          </div>
          <div class="uk-form-controls uk-margin-top" v-if="!isCompany()">
            <label>Fecha de nacimiento</label>
            <birthdate-picker
              v-model="profile.birth_date"
              @blur="$v.profile.birth_date.$touch()"
            ></birthdate-picker>
            <span class="uk-text-danger" v-if="profile.birth_date && !$v.profile.birth_date.canWork">
            	No tienes la edad mínima para trabajar.
          	</span>
            <span class="uk-text-danger" v-if="$v.profile.birth_date.$dirty && !$v.profile.birth_date.required">
            	Debes indicar que tienes la edad legal para trabajar (No será pública)
          	</span>
          </div>
        </div>
      </div>

      <div class="uk-grid">
        <div class="uk-width-1-1">
          <h3>Datos de contacto</h3>
        </div>
        <div class="uk-width-1-2@m">
          <div class="uk-form-controls uk-margin-top">
            <label>Teléfono</label>
            <input
              type="text" class="uk-input"
              v-model.lazy="profile.phone"
              uk-tooltip="No será público"
              @blur="profile.phone = profile.phone.replace(/[^0-9\+]/ig, '')"
            />
          </div>
          <div class="uk-form-controls uk-margin-top">
            <label>Página web</label>
            <input
              type="text"
              class="uk-input"
              v-model.lazy="profile.url"
              @blur="profile.url = urlize(profile.url); $v.profile.url.$touch()"
            />
            <span class="uk-text-warning" v-if="$v.profile.url.$invalid" v-html="labels.url"></span>
          </div>
        </div>
        <div class="uk-width-1-2@m">
          <div class="uk-form-controls uk-margin-top">
            <label>Linkedin</label>
            <input
              type="text"
              class="uk-input"
              v-model.lazy="profile.linkedin"
              @blur="profile.linkedin = urlize(profile.linkedin); $v.profile.linkedin.$touch()"
            />
            <span class="uk-text-warning" v-if="$v.profile.linkedin.$invalid" v-html="labels.url"></span>
          </div>
          <div class="uk-form-controls uk-margin-top">
            <label>Usuario de X</label>
            <input
              type="text"
              class="uk-input"
              v-model="profile.twitter"
              placeholder="@miusuario"
              @blur="$v.profile.twitter.$touch()"
            />
          </div>
          <span class="uk-text-warning" v-if="$v.profile.twitter.$invalid">
            Este campo <strong>no es obligatorio</strong>, pero si lo quieres rellenar, 
            debes introducir tu usuario de Twitter con con el formato <code>@miusuario</code>
          	</span>
        </div>
      </div>

      <div class="uk-text-right uk-margin-large-top uk-margin-large-bottom">
        <button
          v-if="!signup"
          @click="mayClean(); $parent.$emit('profile.save');"
          class="uk-button uk-button-dmtk"
        >Guardar
        </button>
        <router-link v-if="signup" to="/experiencia" class="uk-button uk-button-primary uk-button-bold">
          Siguiente
        </router-link>
      </div>

    </div>
  `,
};
